module.exports = __webpack_public_path__ + "static/media/poll-h.7d964dd0.svg";